import { Component, OnInit, Host, AfterViewInit } from '@angular/core';
import { Renderer3D } from '../../renderer-3D.service';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
    selector: 'scene-overlay',
    templateUrl: './scene-overlay.component.html',
    styleUrls: ['./scene-overlay.component.scss'],
    standalone: false
})
export class SceneOverlayComponent implements AfterViewInit {
    renderer: Renderer3D;
    groundControl: AbstractControl = new FormControl();
    defaultSettings;

    constructor(
    ) {}

    ngAfterViewInit() {
        this.groundControl.valueChanges.subscribe((showGround) => {
            if (showGround)
                this.renderer.scene.ground.opacity = 1;
            else
                this.renderer.scene.ground.opacity = .65;
        });

        this.renderer.scene.when(() => {
            (this.renderer.scene.ground.surfaceColor as any) = "#fff";
            this.renderer.scene.ground.opacity = .6;
            this.groundControl.setValue(this.renderer.scene.ground.opacity === 1);
        });
    }

    resetView() {
        this.renderer.resetCameraPosition();
    }
}
